import { useEffect, useState } from 'react';
import { downloadUrl } from '../files/api';

/**
 * An image this product stores, drawn from a signed link (Phase 118).
 *
 * The same shape as `StoredAvatar` without the person: nothing in this product's storage is public,
 * so every stored image is reached through a short-lived signed URL asked for when it is actually
 * drawn. Renders nothing at all until the link arrives, and nothing ever if it fails — a broken
 * image in the corner of the screen reads as something wrong with the product.
 */
export function StoredImage({
  fileId,
  alt,
  className,
}: {
  fileId: string;
  alt: string;
  className?: string;
}): React.JSX.Element | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;

    downloadUrl(fileId)
      .then((ticket) => {
        if (alive) setUrl(ticket.url);
      })
      .catch(() => {
        if (alive) setUrl(null);
      });

    return () => {
      alive = false;
    };
  }, [fileId]);

  if (!url) return null;

  return <img src={url} alt={alt} className={className} />;
}
